import Box from '@mui/material/Box'

const NotFound = () => {
    return(
        <Box sx={{
            display: 'flex',
            justifyContent: 'center'
        }}>
            <h1>Page not found!</h1>
        </Box>
    )
}

export default NotFound